import React from 'react';
import { Button, Tooltip } from '../../../../shared/ui';
import { IconMap } from '../../../../shared/sprite';

export const CommentHoveringButton: React.FC<{
  onClick: () => void;
}> = ({ onClick }) => {
  return (
    <Tooltip
      hideArrow
      alignOffset={4}
      trigger={
        <Button
          color="transparent"
          variant="icon"
          iconLeftName={IconMap.MessagePlusSquare02}
          iconLeftWidth={24}
          onClick={onClick}
          size="sm"
          iconBlockClassName="text-gray-600"
        />
      }
    >
      Click to add comment
    </Tooltip>
  );
};
